<template>
  <div class="wx-service vh100">
    <div class="service-text">
      <p>AI课程需要在小程序进行学习</p>
      <p>扫描下方二维码立即学习</p>
    </div>

    <div class="service-code">
      <img src="../assets/images/code-image.png" alt />
      <div class="code-img">
        <img :src="qrCode" alt />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      qrCode: ''
    }
  },

  created () {
    let baseImage = this.$store.state.signUpCourseInfo.qrCodeImage || sessionStorage.getItem('qrCodeImage')
    let imgData = baseImage.replace(/[\r\n]/g, '')
    this.qrCode = 'data:image/png;base64,' + imgData
  }
}
</script>

<style lang="scss" scoped>
@charset "UTF-8";
@import "../style/main";

.wx-service {
  padding-top: rem(206);
  box-sizing: border-box;
  .service-text {
    text-align: center;
    color: #333;

    p {
      line-height: rem(42);
      &:nth-child(1) {
        font-size: rem(34);
      }

      &:nth-child(2) {
        font-size: rem(30);
      }
    }
  }

  .service-code {
    position: relative;
    margin-top: rem(246);
    img {
      width: 100%;
    }

    .code-img {
      position: absolute;
      width: rem(325);
      height: rem(325);
      border: rem(15) solid #daccbe;
      border-radius: rem(10);
      left: 0;
      right: 0;
      top: rem(-133);
      margin: auto;

      img {
        height: 100%;
      }
    }
  }
}
</style>